import React from 'react';
import './KnowMore.css';
import chevronDown from '../../assets/chevron-down.svg';
import logo_agroinsider_color from '../../assets/logo-agroinsider-color.svg';
import imgPegadaCarbono from '../../assets/pegada_carbono.jpg';
import imgCarbonEmissions from '../../assets/carbonEmissions.jpg';
import img3 from '../../assets/img_3.jpg';
import { Accordion, AccordionItem as Item } from '@szhsin/react-accordion';
import styles from "./styles.module.css";
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import logo_footer_color from '../../assets/logos_footer_color.svg';
import LanguageSwitcher from '../../components/LanguageSwitcher/LanguageSwitcher';

const KnowMore = ({ Type, setType }) => {
    const { t } = useTranslation();
    const navigate = useNavigate(); // Para navegação programática

    const AccordionItem = ({ header, position, img, ...rest }) => (
        <Item
            {...rest}
            header={
                <>
                    <span className={styles.positionHeadNumber}>{position}.</span>
                    <span className={styles.positionHeadText}>{header}</span>
                    <img className={styles.chevron} src={chevronDown} alt="Chevron Down" />
                </>
            }
            className={styles.item}
            buttonProps={{
                className: ({ isEnter }) =>
                    `${styles.itemBtn} ${isEnter && styles.itemBtnExpanded}`,
            }}
            contentProps={{ className: styles.itemContent }}
            panelProps={{ className: styles.itemPanel }}
        />
    );

    const handleNavigate = (path) => {
        navigate(path);
    };

    const handleGoFirstPage = () => {
        // setReset(true);
        navigate('/');
    }

    return (
        <div className='form-background'>
            <div className='div-agroinsider-logo'>
                <img onClick={() => handleNavigate('/')} style={{ marginBottom: "0px", cursor: "pointer" }} src={logo_agroinsider_color} alt="AgroInsider Logo" className="logo" />
            </div>
            <div style={{ padding: "20px 0px" }} className='farm-profile-description'>
                <span className='farm-profile-title'>{t('KnowMore.title')}</span>
                <span className='farm-profile-title' style={{ fontSize: "18px" }}>{t('KnowMore.description')}</span>
            </div>
            <div className="accordion-content">
                <div className="accordion">
                    {/* `transitionTimeout` prop should be equal to the transition duration in CSS */}
                    <Accordion transition transitionTimeout={250}>
                        <AccordionItem position="1" header={t("KnowMore.item1-header")}>
                            <img className={styles.imgAccordionContent} src={imgPegadaCarbono} alt="img" />
                            <div className={styles.divAccordionContent}>
                                <span className={styles.spanAccordionContent}>
                                    {t("KnowMore.item1-content")}
                                </span>
                                <span className={styles.spanAccordionContent}>
                                    {t("KnowMore.item1-content2")}
                                </span>
                            </div>
                        </AccordionItem>

                        <AccordionItem position="2" header={t("KnowMore.item2-header")}>
                            <img className={styles.imgAccordionContent} src={imgCarbonEmissions} alt="img" />
                            <div className={styles.divAccordionContent}>
                                <span className={styles.spanAccordionContent}>
                                    {t("KnowMore.item2-content")}
                                </span>
                                <span className={styles.spanAccordionContent}>
                                    {t("KnowMore.item2-content2")}
                                </span>
                            </div>
                        </AccordionItem>

                        <AccordionItem position="3" header={t("KnowMore.item3-header")}>
                            <img className={styles.imgAccordionContent} src={img3} alt="img" />
                            <div className={styles.divAccordionContent}>
                                <span className={styles.spanAccordionContent}>
                                    {t("KnowMore.item3-content")}
                                </span>
                                <span className={styles.spanAccordionContent}>
                                    {t("KnowMore.item3-content2")}
                                </span>
                                <ol className={styles.olAccordion}>
                                    <li className={styles.spanAccordionContent}>
                                        {t("KnowMore.item3-content3")}
                                    </li>
                                    <li className={styles.spanAccordionContent}>
                                        {t("KnowMore.item3-content4")}
                                    </li>
                                    <li className={styles.spanAccordionContent}>
                                        {t("KnowMore.item3-content5")}
                                    </li>
                                </ol>
                            </div>
                        </AccordionItem>
                    </Accordion>

                    <div className={styles.divButtonsKnowMore}>
                        <button className="form-next-button" onClick={() => handleNavigate('/general-information')}>{t('calculate_carbon_footprint')}</button>
                        <button style={{ maxWidth: "200px" }} className="form-next-button" onClick={() => handleNavigate('/ask-call-form')}>{t('KnowMore.PERSONALIZED_CONSULTING')}</button>
                    </div>
                    <LanguageSwitcher />
                    <div className='div-logo-footer-color'>
                        <img src={logo_footer_color} alt="AgroInsider Logo" className="logo" />
                    </div>
                    <div className={styles.divButtonsKnowMore}>
                        <button onClick={() => handleGoFirstPage()} className='initial-page-button'>
                            <span className='arrow-icon'>←</span>
                            <span>{t('initial_page')}</span>
                        </button>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default KnowMore;
